import { useWsmDealerCustomerAssignMutation, useWsmDealerGroupCodesQuery } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import { getMutationState } from "@dashboard/misc";
import useCustomerSearch from "@dashboard/searches/useCustomerSearch";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import React from "react";
import { useIntl } from "react-intl";

import WsmDealerCustomerDetailsPage from "../components/WsmDealerCustomerDetailsPage/WsmDealerCustomerDetailsPage";
import { sectionMessages } from "../messages";
import { wsmDealerCustomerUrl } from "../urls";
import { emptyCustomerFormData, getCustomerAssignInput, getCustomerLabel, getGroupLabel } from "../utils";

const GROUP_CHOICES = 100;

export const WsmDealerCustomerAssignView = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();
  const { search, result } = useCustomerSearch({
    variables: { after: null, first: 20, query: "" },
  });
  const { data: groupData } = useWsmDealerGroupCodesQuery({
    variables: { first: GROUP_CHOICES },
  });
  const [assign, assignOpts] = useWsmDealerCustomerAssignMutation({
    onCompleted: response => {
      const assigned = response.wsmDealerCustomerAssign?.dealerCustomer;

      if (assigned) {
        notify({ status: "success", text: intl.formatMessage(commonMessages.savedChanges) });
        navigate(wsmDealerCustomerUrl(assigned.id));
      }
    },
  });
  const errors = assignOpts.data?.wsmDealerCustomerAssign?.errors ?? [];

  return (
    <WsmDealerCustomerDetailsPage
      title={intl.formatMessage(sectionMessages.customerAssignTitle)}
      initialData={emptyCustomerFormData()}
      customerOptions={(mapEdgesToItems(result.data?.search) ?? []).map(user => ({
        value: user.id,
        label: getCustomerLabel(user),
      }))}
      onCustomerSearch={search}
      customerSearchLoading={result.loading}
      groupOptions={(mapEdgesToItems(groupData?.wsmDealerGroups) ?? []).map(group => ({
        value: group.id,
        label: getGroupLabel(group),
      }))}
      errors={errors}
      disabled={assignOpts.loading}
      saveButtonBarState={getMutationState(assignOpts.called, assignOpts.loading, errors)}
      onSubmit={data => assign({ variables: { input: getCustomerAssignInput(data) } })}
    />
  );
};

export default WsmDealerCustomerAssignView;
